<template>
  <div>
    <el-col class="head-info">
      <div class="head-content">
        <el-col :span="6">
          <p>
            <i class="iconfont iconmale"></i>
            专属客户经理：
            {{data_web_common_tourOrder_getTravelAccount.travelAccountManager}}
            {{data_web_common_tourOrder_getTravelAccount.phone}}
          </p>
        </el-col>
        <el-col :span="18" class="flex-end">
          <p class="head-message">您好，{{data_web_common_source_getPermissions.userName}}，欢迎使用胤之旅同业平台</p>
          <p class="head-btn">
            <span class="positiona" @click="__btn_admin_click">管理后台</span>
            <span class="positiona" @click="__btn_logout_click">退出登录</span>
          </p>
        </el-col>
      </div>
    </el-col>
  </div>
</template>
<script>
import web_common_source_getPermissions from "@/lib/common-service/web_common_source_getPermissions";
import redirect_to_user_back_home from "@/lib/common-service/redirect_to_user_back_home";
import redirect_to_login_page from "@/lib/common-service/redirect_to_login_page";
import web_common_tourOrder_getTravelAccount from "@/lib/data-service/default/web_common_tourOrder_getTravelAccount";
import logout from "@/lib/data-service/default/logout";
import Q from "q";

export default {
  data() {
    return {
      data_web_common_source_getPermissions: {
        userName: ``
      },
      data_web_common_tourOrder_getTravelAccount: {
        travelAccountManager: ``,
        phone: ``,
        fromCity: ""
      }
    };
  },
  methods: {
    __btn_admin_click() {
      const __this = this;
      redirect_to_user_back_home();
    },
    __btn_logout_click() {
      const __this = this;
      Q.when()
        .then(function() {
          return logout();
        })
        .then(function(data) {
          // 删除12306的账号本地缓存
          localStorage.removeItem("userInfoVo");
          localStorage.removeItem("trainLoginParams");

          redirect_to_login_page();
        })
        .catch(function(ex) {
          console.error(ex);
          if (ex) {
            if (ex.stack) {
              console.error(ex.stack);
            }
          }
          return Q.reject(ex);
        });
    }
  },
  created() {
    const __this = this;
    web_common_source_getPermissions().then(function(data) {
      __this.data_web_common_source_getPermissions = data;
    });
    web_common_tourOrder_getTravelAccount().then(function(data) {
      __this.data_web_common_tourOrder_getTravelAccount = data;
      __this.data_web_common_tourOrder_getTravelAccount.fromCity =
        data.cityName;
    });
  },
  activated() {},
  watch: {},
  computed: {}
};
</script>
<style lang="less" scoped>
.head-content {
  width: 1200px;
  min-width: 1200px;
  margin: auto;
}

.positiona {
  position: relative;
  z-index: 2;
}

.head-info {
  border-bottom: 1px solid #e5e5e5;
  background: #f9f9f9;
  font-size: 12px;
  color: #6e6e6e;
  padding: 10px 0;
  height: 40px;

  .head-btn {
    span {
      border-left: 1px solid #e5e5e5;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .head-message {
    padding: 0 10px;
  }
}

.local {
  display: flex;
}

.local_icon {
  margin-right: 15px;
}

.local_text {
  cursor: pointer;
  font-size: 14px;
}

.head-seek {
  height: 85px;

  .head-logo {
    //width: 250px;
    height: 45px;
  }

  .head-site {
    font-size: 16px;
    color: #666;

    span {
      padding: 0 5px;
    }
  }

  .head-seek-input {
    width: 500px;

    /deep/ .el-input {
      input {
        border-radius: 0;
      }
    }

    .head-seek-btn {
      height: 40px;
      width: 120px;
      background: #237dc8;
      color: white;

      i {
        padding-right: 5px;
      }
    }
  }

  .head-phone {
    margin-right: 10px;

    p {
      font-size: 12px;
      width: 140px;
      color: #949494;

      &:nth-child(1) {
        font-size: 20px;
        color: #237dc8;
      }
    }
  }

  .head-phone-ico {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    position: relative;
    i {
      width: 100%;
      height: 100%;
      position: absolute;
      top: -20%;
      border-radius: 50%;
      background: #237dc8;
      color: white;
      display: flex;
      align-items: center;
      justify-self: center;
    }
  }

  .nav-right {
    .el-col {
      text-align: right;

      a {
        font-weight: bold;
        color: #626262;
        text-decoration: none;
      }
    }

    .el-col.active {
      a {
        color: #237dc8;
      }
    }
  }
}

.head-nav {
  font-size: 15px;
  height: 42px;
  color: white;
  background: #237dc8;
  position: relative;
  .head-nav-item {
    display: flex;
    width: 1200px;
    height: 100%;
    div {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin: 0 18px;
      height: 100%;
      font-size: 16px;
      position: relative;
      transition: all 0.2s ease;
      // z-index: 100;
      z-index: 40;
      text-align: center;
      &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0;
        transition: height 0.2s ease;
        background: #f8f8f9;
        z-index: -1;
      }
      a {
        text-decoration: none;
        color: white;
      }
    }
  }
}
.city_box {
  position: relative;
}
.navShow {
  position: fixed;
  transition: all 0.3s;
  height: 50px;
  color: rgb(53, 53, 53);
  background: white;
  top: 0;
  box-shadow: 0 0 5px #888;
  z-index: 9999;
}
.noShowText {
  div {
    &:hover {
      color: #237dc8;
      &::after {
        height: 42px;
      }
    }
  }
}
.navShowText {
  div {
    &:hover {
      color: white;
      &::after {
        height: 50px;
        top: 0;
        background: #237dc9;
      }
    }
  }
}

.navLogo {
  position: absolute;
  right: 20%;
  top: 50%;
  transform: translateY(-50%);
  img {
    width: 100px;
  }
}
</style>